import React from 'react'
import ImageUploader from '../nextgen/components/image-upload/ImageUploader'


// Old image uploader is a helper to depracte src/firebase/ImageUploader component.
export default function OldImageUploader({
  storageFolder,
  setFileList,
  fileList,
  maxCount,
  disabledAdd,
  multiple
}) {
  return (
    <div>
      <ImageUploader
        disabledAdd={disabledAdd}
        maxImageSize={maxCount}
        storageFolder={storageFolder}
        fileList={fileList || []}
        setFileList={setFileList}
        multiple={multiple || false}
        thumbMaxDimension={600}
      />
    </div>
  )
}
